// import React from 'react'; 
// import { useInView } from 'react-intersection-observer';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//     faPersonWalking,
//     faPalette,
//     faComments,
//     faIdCard,
//     faDumbbell,
//     faBullhorn,
//     faGavel,
//     faGamepad,
//     faMasksTheater,
//     faGlobe,
//     faArrowRight,
//     faCertificate,
//     faCheckCircle,
//     faPlay,
//     faFileLines,
//     faQrcode,
//     faArrowUpRightFromSquare
// } from '@fortawesome/free-solid-svg-icons';
// import '../../styles/vikshitbharat/main.css';


// const YOUTUBE_VIDEO_ID = 'UoALZPk72_8';
// const YOUTUBE_VIDEO_URL = `https://www.youtube.com/watch?v=${YOUTUBE_VIDEO_ID}`;
// // const YOUTUBE_THUMBNAIL = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/maxresdefault.jpg`;
// const YOUTUBE_THUMBNAIL = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/hqdefault.jpg`;
// const BANNER_IMAGE = 'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/viksit-bharat-2047-1024x341.webp'; 
// const SOP_DOCUMENT_URL = 'https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/SOP.pdf';
// const QR_CODE_IMAGE = 'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/mygov-qr.webp';
// const QR_SCAN_DESTINATION_URL = 'https://innovateindia.mygov.in/';

// const activities = [
//     { icon: faPersonWalking, title: 'Walkathon' },
//     { icon: faPalette, title: 'Poster Competitions' },
//     { icon: faComments, title: 'Debate Competition' },
//     { icon: faIdCard, title: 'My Bharat Registration Drive' },
//     { icon: faDumbbell, title: 'Fitness & Wellness Activities' },
//     { icon: faBullhorn, title: 'Awareness Rally' },
//     { icon: faGavel, title: 'Youth Parliament' },
//     { icon: faGamepad, title: 'Games Competitions' },
//     { icon: faMasksTheater, title: 'Nukkad Nataks (Street Plays)' },
// ];


// const steps = [
//     {
//         title: 'Visit the Official Portal',
//         desc: (
//             <>
//                 Go to the official MyGov portal:{' '}
//                 <a
//                     href="https://www.mygov.in/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="vb-inline-link"
//                 >
//                     www.mygov.in
//                 </a>{' '}
//                 and navigate to the Viksit Bharat@2047 Consultation section.
//             </>
//         ),
//     },
//     {
//         title: 'Click to Share Ideas',
//         desc: 'Click on the "Click Here to Share Your Ideas" button.',
//     },
//     {
//         title: 'Register',
//         desc: 'Register using your institutional email ID by selecting the "Register Now" option.',
//     },
//     {
//         title: 'Login',
//         desc: 'Once registered, log in to the MyGov portal using your credentials.',
//     },
//     {
//         title: 'Respond Thoughtfully',
//         desc: (
//             <>
//                 On the portal, respond to the following questions:
//                 <ul className="vb-step-sublist">
//                     <li>What should a Viksit Bharat look like in 2047 across different sectors?</li>
//                     <li>What actions are needed to achieve this vision?</li>
//                     <li>What is your individual contribution towards realizing Viksit Bharat@2047?</li>
//                 </ul>
//             </>
//         ),
//     },
//     {
//         title: 'Submit Your Idea',
//         desc: 'Submit your idea, clearly mentioning your vision and personal role/contribution towards building a developed India.',
//     },
//     {
//         title: 'Get Your Certificate',
//         desc: 'Enter your email ID to receive a certificate of participation, and download it from the link sent to your email.',
//     },
// ];


// /* ============================================
//    NEW: SHOWCASE SECTION (top of page)
//    Banner image + YouTube card + QR card + CTAs
//    ============================================ */
// const ShowcaseSection = () => {

//     return (
//         <section className="vb-showcase">
//             <div className="container">
//                 {/* Top banner image */}
//                 <div className="vb-banner-wrap">
//                         <img
//                             src={BANNER_IMAGE}
//                             alt="Ideas for the Vision - Viksit Bharat @2047"
//                             className="vb-banner-img"
//                         />
//                 </div>

//                 {/* Two-column: YouTube card | QR card */}
//                 <div className="row g-4 mt-1">
//                     {/* YouTube video card */}
//                     <div className="col-12 col-lg-6">
//                         <div>
//                             <a
//                                 href={YOUTUBE_VIDEO_URL}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="vb-yt-card"
//                                 aria-label="Watch: PM Modi launches Viksit Bharat @2047: Voice of Youth on YouTube"
//                             >
//                                 <img
//                                     src={YOUTUBE_THUMBNAIL}
//                                     alt="PM Modi launches Viksit Bharat @2047: Voice of Youth"
//                                     className="vb-yt-thumb"
//                                 />
//                                 <span className="vb-yt-play">
//                                     <FontAwesomeIcon icon={faPlay} />
//                                 </span>
//                                 <span className="vb-yt-caption">
//                                     Watch on <strong>YouTube</strong>
//                                 </span>
//                             </a>

//                             {/* Buttons under YouTube card */}
//                             <div className="vb-showcase-btns">
//                                 <a
//                                     href={SOP_DOCUMENT_URL}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="vb-btn-sop"
//                                 >
//                                     <FontAwesomeIcon icon={faFileLines} className="me-2" />
//                                     View SOP's
//                                 </a>
//                                 <a href="#vb-qr-section" className="vb-btn-outline-gold">
//                                     <FontAwesomeIcon icon={faQrcode} className="me-2" />
//                                     View QR Codes
//                                 </a>
//                             </div>
//                         </div>
//                     </div>

//                     {/* QR code card */}
//                     <div className="col-12 col-lg-6" id="vb-qr-section">
//                         <div>
//                             <a
//                                 href={QR_SCAN_DESTINATION_URL}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="vb-qr-card"
//                                 aria-label="Scan or click to visit the MyGov Viksit Bharat website"
//                             >
//                                 <img
//                                     src={QR_CODE_IMAGE}
//                                     alt="QR code to visit MyGov Viksit Bharat @2047 portal"
//                                     className="vb-qr-img"
//                                 />
//                             </a>

//                             {/* Button under QR card */}
//                             <div className="vb-showcase-btns vb-showcase-btns-center">
//                                 <a
//                                     href={QR_SCAN_DESTINATION_URL}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="vb-btn-gold"
//                                 >
//                                     <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="me-2" />
//                                     Visit Website
//                                 </a>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// const Main = () => {
//     return (
//         <div className="vb-page">
//             {/* SHOWCASE (image / YouTube / QR / SOP) */}
//             <ShowcaseSection />

//             {/* ABOUT */}
//             <section className="vb-section vb-about">
//                 <div className="container">
//                     <div>
//                         <div className="row justify-content-center">
//                             <div className="col-lg-10">
//                                 <h2 className="vb-section-title text-center">About the Initiative</h2>
//                                 <div className="vb-divider mx-auto"></div>
//                                 <p className="vb-para">
//                                     <strong>"Viksit Bharat 2047"</strong> is an initiative aimed at realizing
//                                     India's aspiration of becoming a developed nation by its centennial year
//                                     of independence. As India approaches its 100th year of independence in
//                                     2047, this initiative seeks to mobilize efforts across economic, social,
//                                     environmental, and governance domains to achieve comprehensive and
//                                     sustainable development.
//                                 </p>
//                                 <p className="vb-para">
//                                     The concept envisions India as a leading global power with high standards
//                                     of living, equitable growth, and environmental stewardship. To advance
//                                     this vision among youth, the{' '}
//                                     <strong>"Viksit Bharat Ambassador – Yuva Connect"</strong> program is
//                                     aimed at fostering youth engagement and leadership in the developmental
//                                     transformation of India. The idea is to take the PM's vision of Viksit
//                                     Bharat to maximum youth by conducting 50 programs in educational
//                                     institutions across various states in the country.
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* YUVA CONNECT PROGRAM */}
//             <section className="vb-section vb-yuva">
//                 <div className="container">
//                     <div>
//                         <div className="row justify-content-center">
//                             <div className="col-lg-10">
//                                 <h2 className="vb-section-title text-center">
//                                     Yuva Connect Program – Action Plan
//                                 </h2>
//                                 <div className="vb-divider mx-auto"></div>
//                                 <p className="vb-para">
//                                     As part of the nationwide initiative{' '}
//                                     <strong>Viksit Bharat@2047 – Yuva Connect Program</strong>, the University
//                                     has envisioned a dynamic series of events designed to inspire, engage, and
//                                     empower students in the shared mission of building a developed India.
//                                 </p>
//                                 <p className="vb-para">
//                                     The initiative comprises a variety of impactful activities that nurture
//                                     awareness, creativity, leadership, fitness, and civic responsibility among
//                                     the youth. Through this platform, the University aims to instill a deep
//                                     sense of purpose and national pride in students, encouraging them to take
//                                     an active role in shaping the country's future.
//                                 </p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* ACTIVITIES GRID */}
//                     <div className="row g-4 mt-3">
//                         {activities.map((item, idx) => (
//                             <div className="col-6 col-md-4 col-lg-3" key={idx}>
//                                 <div>
//                                     <div className="vb-activity-card">
//                                         <div className="vb-activity-icon">
//                                             <FontAwesomeIcon icon={item.icon} />
//                                         </div>
//                                         <p className="vb-activity-title">{item.title}</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     <div>
//                         <p className="vb-para vb-supervision-note text-center">
//                             All events will be organized under the supervision of dedicated faculty
//                             members, supported by enthusiastic student volunteers, along with{' '}
//                             <strong>NCC, NSS,</strong> and various university clubs.
//                         </p>
//                     </div>
//                 </div>
//             </section>

//             {/* STEPS TO SUBMIT FEEDBACK */}
//             <section className="vb-section vb-steps-section">
//                 <div className="container">
//                     <div>
//                         <h2 className="vb-section-title text-center">
//                             Steps to Submit Feedback on MyGov Portal
//                         </h2>
//                         <div className="vb-divider mx-auto"></div>
//                         <p className="vb-para text-center vb-steps-intro">
//                             Students are required to follow the steps below while submitting their
//                             feedback and ideas as part of the Viksit Bharat@2047 initiative.
//                         </p>
//                     </div>

//                     <div className="row justify-content-center">
//                         <div className="col-lg-9">
//                             <div className="vb-timeline">
//                                 {steps.map((step, idx) => (
//                                     <div key={idx} className="vb-timeline-item">
//                                         <div className="vb-timeline-number">{idx + 1}</div>
//                                         <div className="vb-timeline-content">
//                                             <h3 className="vb-timeline-title">{step.title}</h3>
//                                             <p className="vb-timeline-desc">{step.desc}</p>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>

//                     <div>
//                         <div className="vb-cta-box text-center">
//                             <FontAwesomeIcon icon={faCertificate} className="vb-cta-icon" />
//                             <h3>Ready to Contribute Your Vision?</h3>
//                             <p>Register on MyGov and be a part of India's growth story.</p>
//                             <a
//                                 href="https://www.mygov.in/"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="vb-btn-primary"
//                             >
//                                 <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
//                                 Visit MyGov Portal
//                             </a>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default Main;




import React from 'react';
import { useInView } from 'react-intersection-observer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPersonWalking,
    faPalette,
    faComments,
    faIdCard,
    faDumbbell,
    faBullhorn,
    faGavel,
    faGamepad,
    faMasksTheater,
    faGlobe,
    faArrowRight,
    faCertificate,
    faCheckCircle,
    faPlay,
    faFileLines,
    faQrcode,
    faArrowUpRightFromSquare,
    faEye,
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/vikshitbharat/main.css';

// old_Id = 'UoALZPk72_8'
const YOUTUBE_VIDEO_ID = 'qa9L5ZD30jE';
const YOUTUBE_VIDEO_URL = `https://www.youtube.com/watch?v=${YOUTUBE_VIDEO_ID}`;
const YOUTUBE_THUMBNAIL = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/hqdefault.jpg`;
const BANNER_IMAGE = 'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/viksit-bharat-2047-1024x341.webp';
const SOP_DOCUMENT_URL = 'https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/SOP.pdf';
const QR_CODE_IMAGE = 'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/mygov-qr.webp';
const QR_SCAN_DESTINATION_URL = 'https://innovateindia.mygov.in/';

const newsItems = [
    {
        id: 'news-1',
        title: 'Organisation of Speech Competition on “Viksit Bharat” and Government Welfare Schemes',
        link: 'https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Quiz%20Competition%20(INDIA%E2%80%99S%20DEVELOPMENT%20JOURNEY2025)%20(2).pdf',
    },
    
];

/* ============================================
   LEADERSHIP SECTION DATA
   Replace 'photo' with actual CDN image links
   ============================================ */
const leaders = [
    {
        id: 'leader-pm',
        name: 'Shri Narendra Modi',
        designation: 'Hon\'ble Prime Minister of India',
        photo: 'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Narendra_Modi_Portrait_2026.webp',
    },
    {
        id: 'leader-cm',
        name: 'Shri Yogi Adityanath',
        designation: 'Hon\'ble Chief Minister, Uttar Pradesh',
        photo: 'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/CM%20Yogi.webp',
    },
    {
        id: 'leader-governor',
        name: 'Smt. Anandiben Patel',
        designation: 'Hon\'ble Governor of Uttar Pradesh',
        photo: 'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/up%20governor.webp',
    },
];

/* ============================================
   ACTIVITIES DATA
   Each activity gets a unique modalId + an
   `images` array — replace with real CDN links.
   Add as many images as needed per activity.
   ============================================ */
const activities = [
    {
        icon: faPersonWalking,
        title: 'Walkathon',
        modalId: 'vbModalWalkathon',
        carouselId: 'vbCarouselWalkathon',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/jpg/REPLACE/walkathon/1.jpg',
        ],
    },
    {
        icon: faPalette,
        title: 'Poster Competitions',
        modalId: 'vbModalPoster',
        carouselId: 'vbCarouselPoster',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Poster/aiyuqwkawvlimwlxbois.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Poster/i0ajannzmsinbocfqpeb.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Poster/qxpz8cfvhfu0xskbpcbq.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Poster/qxvdho6p3haqraoxc2s8.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Poster/rvssorwve2r3w3vbzzzt.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Poster/zqrpzneowjkst9ecykkv.webp',
        ],
    },
    {
        icon: faComments,
        title: 'Debate Competition',
        modalId: 'vbModalDebate',
        carouselId: 'vbCarouselDebate',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/jpg/REPLACE/debate/1.jpg',
        ],
    },
    {
        icon: faIdCard,
        title: 'My Bharat Registration Drive',
        modalId: 'vbModalRegistration',
        carouselId: 'vbCarouselRegistration',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/jpg/REPLACE/registration/1.jpg',
        ],
    },
    {
        icon: faDumbbell,
        title: 'Fitness & Wellness Activities',
        modalId: 'vbModalFitness',
        carouselId: 'vbCarouselFitness',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Fittness/d6hpejglpnfy8lolauo4.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Fittness/f6ex6jmjfogjzah3i9vv.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Fittness/h45wdbnkstdaf7gxbrqw.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Fittness/siruausuown3fwlimzpl.webp',
        ],
    },
    {
        icon: faBullhorn,
        title: 'Awareness Rally',
        modalId: 'vbModalRally',
        carouselId: 'vbCarouselRally',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Rally/eq8yybzfwimuy0ka4svv.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Rally/ghejuonyubt1dkfrkaof.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Rally/h3ei4ptpzy6em9voy7cq.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Rally/jjt0yvl3mucdf1vvotpo.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Rally/ngmt6g4tjivpl39lu7h1.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Rally/rn8vb2m0n06mozplrilr.webp',
        ],
    },
    {
        icon: faGavel,
        title: 'Youth Parliament',
        modalId: 'vbModalParliament',
        carouselId: 'vbCarouselParliament',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Youth%20Parliment/qygadmydqqwsl2o0so8i.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Youth%20Parliment/rsxwqjdjydeczl8wzsnl.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Youth%20Parliment/tpvytnofw4y2bnajbdob.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Youth%20Parliment/viwgp8xbrkwphfjnvbzu.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Youth%20Parliment/xuraddbxvn5cloaaeqen.webp',
            'https://cdn.ccsuniversity.ac.in/public/webp/2026/09/Youth%20Parliment/zbpkycvoaoe8ch7pwkqw.webp',
        ],
    },
    {
        icon: faGamepad,
        title: 'Games Competitions',
        modalId: 'vbModalGames',
        carouselId: 'vbCarouselGames',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/jpg/REPLACE/games/1.jpg',
        ],
    },
    {
        icon: faMasksTheater,
        title: 'Nukkad Nataks (Street Plays)',
        modalId: 'vbModalNukkad',
        carouselId: 'vbCarouselNukkad',
        images: [
            'https://cdn.ccsuniversity.ac.in/public/jpg/REPLACE/nukkad/1.jpg',
        ],
    },
];

const steps = [
    {
        title: 'Visit the Official Portal',
        desc: (
            <>
                Go to the official MyGov portal:{' '}
                <a
                    href="https://www.mygov.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="vb-inline-link"
                >
                    www.mygov.in
                </a>{' '}
                and navigate to the Viksit Bharat@2047 Consultation section.
            </>
        ),
    },
    {
        title: 'Click to Share Ideas',
        desc: 'Click on the "Click Here to Share Your Ideas" button.',
    },
    {
        title: 'Register',
        desc: 'Register using your institutional email ID by selecting the "Register Now" option.',
    },
    {
        title: 'Login',
        desc: 'Once registered, log in to the MyGov portal using your credentials.',
    },
    {
        title: 'Respond Thoughtfully',
        desc: (
            <>
                On the portal, respond to the following questions:
                <ul className="vb-step-sublist">
                    <li>What should a Viksit Bharat look like in 2047 across different sectors?</li>
                    <li>What actions are needed to achieve this vision?</li>
                    <li>What is your individual contribution towards realizing Viksit Bharat@2047?</li>
                </ul>
            </>
        ),
    },
    {
        title: 'Submit Your Idea',
        desc: 'Submit your idea, clearly mentioning your vision and personal role/contribution towards building a developed India.',
    },
    {
        title: 'Get Your Certificate',
        desc: 'Enter your email ID to receive a certificate of participation, and download it from the link sent to your email.',
    },
];


/* ============================================
   NEWS SECTION
   Serial No. | Title | View button
   ============================================ */
const NewsSection = () => {
    return (
        <section className="vb-section vb-news-section">
            <div className="container">
                <h2 className="vb-section-title text-center">News</h2>
                <div className="vb-divider mx-auto"></div>

                <div className="row justify-content-center mt-2">
                    <div className="col-lg-10">
                        <div className="vb-news-table-wrap">
                            <table className="vb-news-table">
                                <thead>
                                    <tr>
                                        <th className="vb-news-col-sno">S.No.</th>
                                        <th>Title</th>
                                        <th className="vb-news-col-action">View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {newsItems.map((news, idx) => (
                                        <tr key={news.id}>
                                            <td data-label="S.No." className="vb-news-col-sno">
                                                {idx + 1}
                                            </td>
                                            <td data-label="Title" className="vb-news-title">
                                                {news.title}
                                            </td>
                                            <td data-label="View" className="vb-news-col-action">
                                                <a
                                                    href={news.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="vb-news-view-btn"
                                                >
                                                    <FontAwesomeIcon icon={faEye} className="me-2" />
                                                    View
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ============================================
   LEADERSHIP SECTION (before About the Initiative)
   ============================================ */
const LeadershipSection = () => {
    return (
        <section className="vb-section vb-leaders-section">
            <div className="container">
                <h2 className="vb-section-title text-center">Vision Leadership</h2>
                <div className="vb-divider mx-auto"></div>
                <div className="row g-4 justify-content-center mt-2">
                    {leaders.map((leader) => (
                        <div className="col-10 col-sm-6 col-lg-4" key={leader.id}>
                            <div className="vb-leader-card">
                                <div className="vb-leader-photo-wrap">
                                    <img
                                        src={leader.photo}
                                        alt={leader.name}
                                        className="vb-leader-photo"
                                    />
                                </div>
                                <h3 className="vb-leader-name">{leader.name}</h3>
                                <p className="vb-leader-designation">{leader.designation}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

/* ============================================
   SHOWCASE SECTION (top of page)
   Banner image + YouTube card + QR card + CTAs
   ============================================ */
const ShowcaseSection = () => {
    return (
        <section className="vb-showcase">
            <div className="container">
                {/* Top banner image */}
                <div className="vb-banner-wrap">
                    <img
                        src={BANNER_IMAGE}
                        alt="Ideas for the Vision - Viksit Bharat @2047"
                        className="vb-banner-img"
                    />
                </div>
                {/* Two-column: YouTube card | QR card */}
                <div className="row g-4 mt-1">
                    {/* YouTube video card */}
                    <div className="col-12 col-lg-6">
                        <div>
                            <a
                                href={YOUTUBE_VIDEO_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="vb-yt-card"
                                aria-label="Watch: PM Modi launches Viksit Bharat @2047: Voice of Youth on YouTube"
                            >
                                <img
                                    src={YOUTUBE_THUMBNAIL}
                                    alt="PM Modi launches Viksit Bharat @2047: Voice of Youth"
                                    className="vb-yt-thumb"
                                />
                                <span className="vb-yt-play">
                                    <FontAwesomeIcon icon={faPlay} />
                                </span>
                                <span className="vb-yt-caption">
                                    Watch on <strong>YouTube</strong>
                                </span>
                            </a>
                            {/* Buttons under YouTube card */}
                            <div className="vb-showcase-btns">
                                <a
                                    href={SOP_DOCUMENT_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="vb-btn-sop"
                                >
                                    <FontAwesomeIcon icon={faFileLines} className="me-2" />
                                    View SOP's
                                </a>
                                <a href="#vb-qr-section" className="vb-btn-outline-gold">
                                    <FontAwesomeIcon icon={faQrcode} className="me-2" />
                                    View QR Codes
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* QR code card */}
                    <div className="col-12 col-lg-6" id="vb-qr-section">
                        <div>
                            <a
                                href={QR_SCAN_DESTINATION_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="vb-qr-card"
                                aria-label="Scan or click to visit the MyGov Viksit Bharat website"
                            >
                                <img
                                    src={QR_CODE_IMAGE}
                                    alt="QR code to visit MyGov Viksit Bharat @2047 portal"
                                    className="vb-qr-img"
                                />
                            </a>
                            {/* Button under QR card */}
                            <div className="vb-showcase-btns vb-showcase-btns-center">
                                <a
                                    href={QR_SCAN_DESTINATION_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="vb-btn-gold"
                                >
                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="me-2" />
                                    Visit Website
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ============================================
   ACTIVITY IMAGE MODAL
   Same pattern as the Gallery page's modals:
   Bootstrap modal + carousel + close button.
   ============================================ */
const ActivityModal = ({ activity }) => {
    const { modalId, carouselId, images, title } = activity;

    return (
        <div className="modal-main">
            <div
                className="modal fade"
                id={modalId}
                aria-hidden="true"
                aria-labelledby={`${modalId}Label`}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div id={carouselId} className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                {images.map((src, idx) => (
                                    <div
                                        className={`carousel-item ${idx === 0 ? 'active' : ''}`}
                                        key={idx}
                                    >
                                        <img src={src} className="d-block w-100" alt={title} />
                                    </div>
                                ))}
                            </div>
                            {images.length > 1 && (
                                <>
                                    <button
                                        className="carousel-control-prev"
                                        type="button"
                                        data-bs-target={`#${carouselId}`}
                                        data-bs-slide="prev"
                                    >
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button
                                        className="carousel-control-next"
                                        type="button"
                                        data-bs-target={`#${carouselId}`}
                                        data-bs-slide="next"
                                    >
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </>
                            )}
                            <div className="close-btn-modal">
                                <button data-bs-dismiss="modal" aria-label="Close">
                                    <i
                                        className="fa fa-times"
                                        aria-hidden="true"
                                        style={{ cursor: 'pointer' }}
                                    ></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Main = () => {
    return (
        <div className="vb-page">
            {/* SHOWCASE (image / YouTube / QR / SOP) */}
            <ShowcaseSection />

            <NewsSection />

            {/* LEADERSHIP (before About the Initiative) */}
            <LeadershipSection />

            {/* ABOUT */}
            <section className="vb-section vb-about">
                <div className="container">
                    <div>
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <h2 className="vb-section-title text-center">About the Initiative</h2>
                                <div className="vb-divider mx-auto"></div>
                                <p className="vb-para">
                                    <strong>"Viksit Bharat 2047"</strong> is an initiative aimed at realizing
                                    India's aspiration of becoming a developed nation by its centennial year
                                    of independence. As India approaches its 100th year of independence in
                                    2047, this initiative seeks to mobilize efforts across economic, social,
                                    environmental, and governance domains to achieve comprehensive and
                                    sustainable development.
                                </p>
                                <p className="vb-para">
                                    The concept envisions India as a leading global power with high standards
                                    of living, equitable growth, and environmental stewardship. To advance
                                    this vision among youth, the{' '}
                                    <strong>"Viksit Bharat Ambassador – Yuva Connect"</strong> program is
                                    aimed at fostering youth engagement and leadership in the developmental
                                    transformation of India. The idea is to take the PM's vision of Viksit
                                    Bharat to maximum youth by conducting 50 programs in educational
                                    institutions across various states in the country.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* YUVA CONNECT PROGRAM */}
            <section className="vb-section vb-yuva">
                <div className="container">
                    <div>
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <h2 className="vb-section-title text-center">
                                    Yuva Connect Program – Action Plan
                                </h2>
                                <div className="vb-divider mx-auto"></div>
                                <p className="vb-para">
                                    As part of the nationwide initiative{' '}
                                    <strong>Viksit Bharat@2047 – Yuva Connect Program</strong>, the University
                                    has envisioned a dynamic series of events designed to inspire, engage, and
                                    empower students in the shared mission of building a developed India.
                                </p>
                                <p className="vb-para">
                                    The initiative comprises a variety of impactful activities that nurture
                                    awareness, creativity, leadership, fitness, and civic responsibility among
                                    the youth. Through this platform, the University aims to instill a deep
                                    sense of purpose and national pride in students, encouraging them to take
                                    an active role in shaping the country's future. Click on any activity
                                    below to view photos.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* ACTIVITIES GRID — now clickable, opens image modal */}
                    <div className="row g-4 mt-3">
                        {activities.map((item, idx) => (
                            <div className="col-6 col-md-4 col-lg-3" key={idx}>
                                <div>
                                    <a
                                        href={`#${item.modalId}`}
                                        data-bs-toggle="modal"
                                        role="button"
                                        className="vb-activity-card vb-activity-card-clickable"
                                    >
                                        <div className="vb-activity-icon">
                                            <FontAwesomeIcon icon={item.icon} />
                                        </div>
                                        <p className="vb-activity-title">{item.title}</p>
                                        <span className="vb-activity-view">View Photos</span>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div>
                        <p className="vb-para vb-supervision-note text-center">
                            All events will be organized under the supervision of dedicated faculty
                            members, supported by enthusiastic student volunteers, along with{' '}
                            <strong>NCC, NSS,</strong> and various university clubs.
                        </p>
                    </div>
                </div>
            </section>

            {/* STEPS TO SUBMIT FEEDBACK */}
            <section className="vb-section vb-steps-section">
                <div className="container">
                    <div>
                        <h2 className="vb-section-title text-center">
                            Steps to Submit Feedback on MyGov Portal
                        </h2>
                        <div className="vb-divider mx-auto"></div>
                        <p className="vb-para text-center vb-steps-intro">
                            Students are required to follow the steps below while submitting their
                            feedback and ideas as part of the Viksit Bharat@2047 initiative.
                        </p>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="vb-timeline">
                                {steps.map((step, idx) => (
                                    <div key={idx} className="vb-timeline-item">
                                        <div className="vb-timeline-number">{idx + 1}</div>
                                        <div className="vb-timeline-content">
                                            <h3 className="vb-timeline-title">{step.title}</h3>
                                            <p className="vb-timeline-desc">{step.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="vb-cta-box text-center">
                            <FontAwesomeIcon icon={faCertificate} className="vb-cta-icon" />
                            <h3>Ready to Contribute Your Vision?</h3>
                            <p>Register on MyGov and be a part of India's growth story.</p>
                            <a
                                href="https://www.mygov.in/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="vb-btn-primary"
                            >
                                <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                                Visit MyGov Portal
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* ACTIVITY PHOTO MODALS */}
            {activities.map((activity) => (
                <ActivityModal activity={activity} key={activity.modalId} />
            ))}
        </div>
    );
};

export default Main;